import React, { KeyboardEvent, useRef } from "react";
import {
  ButtonRow,
  FormWrapper,
  IconButton,
  InputContainer,
  InputWrapper,
  RightButtonGroup,
  SendButton,
  TextArea,
  TextAreaWrapper,
} from "./__styles__/ChatInput";

export interface ChatInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  disabled?: boolean;
  placeholder?: string;
}

const ChatInput: React.FC<ChatInputProps> = ({
  value,
  onChange,
  onSubmit,
  disabled = false,
  placeholder = "Let's get started...",
}) => {
  const formRef = useRef<HTMLFormElement>(null);

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      formRef.current?.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      );
    }
  };

  // Auto-resize textarea based on content
  const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = e.target;
    onChange(e);

    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = "auto";
    // Set height to scrollHeight to fit content
    textarea.style.height = Math.min(textarea.scrollHeight, 120) + "px";
  };

  return (
    <FormWrapper
      ref={formRef}
      onSubmit={e => {
        e.preventDefault();
        if (!disabled) {
          onSubmit(e);
        }
      }}
    >
      <InputContainer>
        <InputWrapper>
          <TextAreaWrapper>
            <TextArea
              value={value}
              onChange={handleTextAreaChange}
              onKeyPress={handleKeyPress}
              placeholder={placeholder}
              disabled={disabled}
              rows={1}
            />
          </TextAreaWrapper>
          <ButtonRow>
            <IconButton
              type="button"
              disabled={disabled}
              aria-label="Add attachment"
            >
              +
            </IconButton>
            <RightButtonGroup>
              <SendButton
                type="submit"
                disabled={disabled || !value.trim()}
                aria-label="Send message"
              >
                →
              </SendButton>
            </RightButtonGroup>
          </ButtonRow>
        </InputWrapper>
      </InputContainer>
    </FormWrapper>
  );
};

export default ChatInput;
